import amplitude from 'amplitude-js'

export const ampInstance = amplitude.getInstance()

export const initAmplitude = () => {
  //amplitude.getInstance().init(process.env.REACT_APP_AMPLITUDE)
}
export const sendAmplitudeData = (eventType, eventProperties) => {
  //amplitude.getInstance().logEvent(eventType, eventProperties)
}

export const setAmplitudeUserId = userId => {
  //amplitude.getInstance().setUserId(userId)
}